/**
 * P4-Insights der Optimierungen-Seite: Fortschritt, NBA-Karten, Regel-Abdeckung.
 * Verträge: docs/superpowers/specs/2026-07-16-optimierungen-p4-loop-guidance-design.md §5.2/5.3.
 */

import apiClient from '../api-client'

const BASE = '/api/v1'

export interface ProgressPoint {
  date: string
  value: number
}

export interface IssuesProgress {
  closed_last_7d: number
  closed_prev_7d: number
  open_issues: number
  open_issues_series: ProgressPoint[]
  avg_score: number
  avg_score_series: ProgressPoint[]
  score_scope_channel_id: string | null
}

export type NbaCard =
  | {
      type: 'top_seller_fix'
      channel_id: string
      channel_name: string
      product_count: number
      revenue_30d_sum: number
      product_ids: string[]
    }
  | { type: 'rule_gap'; channel_id: string; channel_name: string }
  | { type: 'pending_review'; count: number; run_id: string | null }

export interface RuleCoverageEntry {
  channel_id: string
  name: string
  rules_count: number
  open_issues: number
  product_count: number
}

export async function getIssuesProgress(channelId?: string | null): Promise<{ success: boolean; progress: IssuesProgress }> {
  const qs = channelId ? `?channel_id=${encodeURIComponent(channelId)}` : ''
  const res = await apiClient.get(`${BASE}/products/issues/progress${qs}`)
  return res.data
}

export async function getNbaCards(): Promise<{ success: boolean; cards: NbaCard[] }> {
  const res = await apiClient.get(`${BASE}/products/issues/nba`)
  return res.data
}

export async function getRuleCoverage(): Promise<{ success: boolean; channels: RuleCoverageEntry[] }> {
  const res = await apiClient.get(`${BASE}/products/issues/rule-coverage`)
  return res.data
}
